import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=798a79b2&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=798a79b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a79b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('798a79b2')) {
      api.createRecord('798a79b2', component.options)
    } else {
      api.reload('798a79b2', component.options)
    }
    module.hot.accept("./OrderSummary.vue?vue&type=template&id=798a79b2&scoped=true", function () {
      api.rerender('798a79b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderSummary.vue"
export default component.exports